{
  movingFn: (arr, windowSize, fn) -> do
    if windowSize > count(arr) then
      perform(@dvala.error, "Expected windowSize <= array length")
    else
      null
    end;
    for(i in range(count(arr) - windowSize + 1)) -> do
      fn(slice(arr, i, i + windowSize));
    end;
  end,
  runningFn: (arr, fn) -> for(i in range(count(arr))) -> do
    fn(slice(arr, 0, i + 1));
  end,
};
